import { createSlice } from "@reduxjs/toolkit";
import { commonservices } from "../CommonServices";
// import { commonservices } from "../Service/CommonServices";

const initialState = {
  Token: null,
  UserInfo: null,
  UserRoleRight: null,
  Organizations: [],
  RejectParametersData: [],
  RejectFAQData: [],
  SignalRKey: null,
  googleString: null,
  inputJS: null,
};
const isValidJSON = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

try {
  const tokenData = localStorage.getItem("Token");
  if (tokenData) {
    initialState.Token = tokenData;
  } else {
    commonservices.clearLocalStorage();
    //localStorage.clear();
  }

  const userInfoData = commonservices.getItem("UserInfo");
  if (userInfoData && isValidJSON(commonservices.getDecryptData("UserInfo"))) {
    initialState.UserInfo = JSON.parse(
      commonservices.getDecryptData("UserInfo")
    );
  } else {
    commonservices.clearLocalStorage();
    //localStorage.clear();
  }

  const userRoleRightData = commonservices.getItem("UserRoleRight");
  if (
    userRoleRightData &&
    isValidJSON(commonservices.getDecryptData("UserRoleRight"))
  ) {
    initialState.UserRoleRight = JSON.parse(
      commonservices.getDecryptData("UserRoleRight")
    );
  } else {
    commonservices.clearLocalStorage();
    //localStorage.clear();
  }

  const organizationData = commonservices.getItem("Organization");
  if (
    organizationData &&
    isValidJSON(commonservices.getDecryptData("Organization"))
  ) {
    initialState.Organizations = JSON.parse(
      commonservices.getDecryptData("Organization")
    );
  } else {
    commonservices.clearLocalStorage();
    //localStorage.clear();
  }
} catch (error) {
  commonservices.clearLocalStorage();
  //localStorage.clear();
}

const UserInfoSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userToken: (state, action) => {
      state.Token = action.payload;
      localStorage.setItem("Token", action.payload);
    },
    userInfo: (state, action) => {
      state.UserInfo = action.payload;
      commonservices.setItem("UserInfo", JSON.stringify(action.payload));
    },
    userRoleRight: (state, action) => {
      state.UserRoleRight = action.payload;
      commonservices.setItem("UserRoleRight", JSON.stringify(action.payload));
    },
    organizations: (state, action) => {
      state.Organizations = action.payload;
      commonservices.setItem("Organization", JSON.stringify(action.payload));
    },
    rejectParameterState: (state, action) => {
      state.RejectParametersData = action.payload;
    },
    rejectFAQState: (state, action) => {
      state.RejectFAQData = action.payload;
    },
    SignalRKey: (state, action) => {
      state.SignalRKey = action.payload;
    },
    googleString: (state, action) => {
      state.googleString = action.payload;
    },
    inputJS: (state, action) => {
      state.inputJS = action.payload;
    },
  },
});

export const {
  userToken,
  userInfo,
  userRoleRight,
  organizations,
  rejectParameterState,
  rejectFAQState,
  SignalRKey,
  googleString,
  inputJS,
} = UserInfoSlice.actions;
export default UserInfoSlice.reducer;
